import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPage from '../components/LegalPage';
import { legalConfig } from '../config/legal';

const CookiePolicy = () => {
  const { t } = useTranslation('legal');
  const entity = { entityName: legalConfig.entityName, email: legalConfig.contactEmail };

  return (
    <LegalPage title={t('cookieTitle')}>
      <p>{t('cookieIntro', entity)}</p>

      <h2>{t('cookieWhat')}</h2>
      <p>{t('cookieWhatBody')}</p>

      <h2>{t('cookieEssential')}</h2>
      <p>{t('cookieEssentialBody')}</p>

      <h2>{t('cookieAnalytics')}</h2>
      <p>{t('cookieAnalyticsBody')}</p>

      <h2>{t('cookieManaging')}</h2>
      <p>{t('cookieManagingBody')}</p>

      <h2>{t('cookieThirdParty')}</h2>
      <p>
        {t('cookieThirdPartyBody')}{' '}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
          policies.google.com/privacy
        </a>.
      </p>

      <h2>{t('cookieContact')}</h2>
      <p>
        {t('cookieContactBody')}{' '}
        <a href={`mailto:${legalConfig.contactEmail}`}>{legalConfig.contactEmail}</a>
      </p>
    </LegalPage>
  );
};

export default CookiePolicy;
